import { render } from "./BaseIcon.vue?vue&type=template&id=7beb8039"
import script from "./BaseIcon.vue?vue&type=script&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script